import { useEffect } from 'react';
import { useGallerySelection } from '@/context/GallerySelectionContext';
import { type Asset } from '@/types/asset';

/**
 * Refreshes a selected `Asset` snapshot in place once its live copy changes reference
 * (e.g. a websocket variant update), the way `useReconcileChildSelection` does for a node.
 */
export const useReconcileSelectedAssetsWithLiveData = (liveAssets: ReadonlyArray<Asset> | undefined) => {
  const { selection, setSelectedAssets } = useGallerySelection();

  useEffect(() => {
    if (selection.kind !== 'assets' || !liveAssets || selection.items.length === 0) {
      return;
    }

    const liveById = new Map(liveAssets.map((asset) => [asset.id, asset]));
    let changed = false;
    const next = selection.items.map((selected) => {
      const live = liveById.get(selected.id);
      if (live && live !== selected) {
        changed = true;
        return live;
      }
      return selected;
    });

    if (changed) {
      setSelectedAssets(next);
    }
  }, [liveAssets, selection, setSelectedAssets]);
};
